<template>
  <div class="text-lg text-gray-400 text-start cursor-pointer">
    <p>{{menuName}}</p>
  </div>
</template>

<script>
export default {
    props: ['menuName']
}
</script>